import React from 'react'
import { connect } from 'react-redux'
import { useTranslation } from 'react-i18next'

// ui-kit
import { useWindowSize } from '@navent-jobs/ui-kit/hooks/window-size'
import { Icon } from '@navent-jobs/ui-kit/components/icon'

// components
import AnchorBar from '../../../../../../components/AnchorBar'

// mixins
import { ContainerAnchorBar, Link } from './mixins'

import { IS_ZONA_JOBS, SITE_ID } from '../../../../../../constants'
import features from '../../../../../../constants/features-per-country'

interface ComponentProps {
  aviso: {
    empresa: {
      id: string | null
      confidencial: boolean
      descripcion: string | null
      videoUrl: string | null
    }
    origenAviso: string | null
  }
  isNavResized?: boolean
  avisosSimilares: boolean
  visibleId?: any
}

const isAnchorCompanyEnabled = aviso => {
  if (!IS_ZONA_JOBS && aviso?.origenAviso === 'ZONAJOBS') return false

  const reviewEnabled = features[SITE_ID || 'BMAR'].reviews.enabled
  return (
    !aviso?.empresa.confidencial &&
    !!aviso?.empresa.id &&
    (!!aviso?.empresa.descripcion || !!aviso?.empresa.videoUrl || reviewEnabled)
  )
}

const Component = ({ aviso, isNavResized, avisosSimilares, visibleId }: ComponentProps) => {
  const { t } = useTranslation()
  const { isMobile, isDesktop, isTabletLandscape } = useWindowSize()
  const isDesktopOrTabletLandscape = isTabletLandscape || isDesktop

  const enabledAnchorCompany = isAnchorCompanyEnabled(aviso)
  const enabledAnchorAvisosRelacionados = !!avisosSimilares

  const showAnchorDetail = features[SITE_ID || 'BMAR'].fichaAviso?.tabs?.detail
  const showAnchorCompany = features[SITE_ID || 'BMAR'].fichaAviso?.tabs?.company && !isDesktopOrTabletLandscape
  const showAnchorAvisosRelacionados = features[SITE_ID || 'BMAR'].fichaAviso?.tabs?.avisosRelacionados

  return (
    <ContainerAnchorBar isNavResized={isNavResized} id="anchorBarComponent">
      <AnchorBar visibleId={visibleId}>
        {showAnchorDetail && (
          <Link key="section-detalle" href="#section-detalle" eventLabel="Detalle del aviso">
            {t('fichaAviso.anchorBar.detalleDelAviso')}
          </Link>
        )}

        {showAnchorCompany && (
          <Link
            isVisible={enabledAnchorCompany}
            key="section-empresa"
            href={!enabledAnchorCompany ? '#' : '#section-empresa'}
            disabled={!enabledAnchorCompany}
            eventLabel="La empresa"
          >
            {t('fichaAviso.anchorBar.empresa')}
          </Link>
        )}

        {showAnchorAvisosRelacionados && (
          <Link
            isVisible={enabledAnchorAvisosRelacionados}
            key="section-avisos"
            href={!enabledAnchorAvisosRelacionados ? '#' : '#section-avisos'}
            disabled={!enabledAnchorAvisosRelacionados}
            withIcon={isMobile}
            eventLabel="Empleos relacionados"
          >
            {isMobile ? (
              <Icon name="icon-light-list-cards" size="20" color="rgba(0, 0, 24, 0.48)" />
            ) : (
              t('fichaAviso.anchorBar.avisosRelacionados')
            )}
          </Link>
        )}
      </AnchorBar>
    </ContainerAnchorBar>
  )
}

const states = ({ activeAvisoStore }) => {
  const { avisosSimilares } = activeAvisoStore
  return {
    avisosSimilares,
  }
}

export default connect(states)(Component)
